export default function FinalCTA() {
  return (
    <section id="contact" className="relative py-32 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/89faaa878c1cb0f1366dcf21f6dd54fc.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Transform Your Outdoor Space?
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
          Let's bring your landscaping vision to life. Get a free consultation and discover how we can create the perfect outdoor environment for you.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="px-8 py-4 bg-emerald-600 text-white rounded-full hover:bg-emerald-700 transition-all text-lg font-semibold shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Get Started Today
          </button>
          <a
            href="tel:3347826042"
            className="px-8 py-4 bg-white text-gray-900 rounded-full hover:bg-gray-100 transition-all text-lg font-semibold shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer flex items-center space-x-2"
          >
            <i className="ri-phone-line"></i>
            <span>(334) 782-6042</span>
          </a>
        </div>
      </div>
    </section>
  );
}
